<template>
  <div>
    <div class="container">
      <template v-if="!landscape">
      <p class="title">强易达<sup>®</sup>血流导向密网支架型号及长度一览表（仅为部分型号）</p>
      <div class="box">
        <div class="inputBox">
          <van-field class="input" v-model="searchValue" type="number" placeholder="请输入近端血管直径" :placeholder-style="{ fontSize: '12px',color: 'red', }" readonly @click="showInput" />&nbsp;mm&nbsp;&nbsp;&nbsp;&nbsp;
          <van-field class="input" v-model="searchValue1" type="number" placeholder="请输入远端血管直径" :placeholder-style="{ fontSize: '12px' }" readonly @click="showInput" />&nbsp;mm
        </div>
        <div class="crCode">
          <p>010575-241213</p>
          <p>专业内容，仅供医疗专业人士参考，严禁翻印及传播</p>
        </div>
      </div>
      <div class="table_header">
        <div class="td">规格</div>
        <div class="td">
          <div>自由态</div>
          <div class="flex_header">
            <span>长度/mm</span>
            <span>短缩率</span>
          </div>
        </div>
        <div class="td">
          <div>名义态</div>
          <div class="flex_header">
            <span>长度/mm</span>
            <span>短缩率</span>
          </div>
        </div>
        <div class="td">
          <div>名义态-0.25</div>
          <div class="flex_header">
            <span>长度/mm</span>
            <span>短缩率</span>
          </div>
        </div>
        <div class="td">
          <div>名义态-0.5</div>
          <div class="flex_header">
            <span>长度/mm</span>
            <span>短缩率</span>
          </div>
        </div>
        <div class="td">装配长度</div>
      </div>
      <div class="table_body">
        <div class="table_body_tr" :class="{'bg': item.bg, 'active': item.active}" :ref="'tr'+ index" v-for="(item, index) in data" :key="index">
          <div class="td">{{ item.SpecificationName }}</div>
          <div class="td flex_td">
            <span>{{ item.FreeStateLen }}</span>
            <span>{{ item.FreeStateRate }}</span>
          </div>
          <div class="td flex_td">
            <span>{{ item.NominalStateLen }}</span>
            <span>{{ item.NominalStateRate }}</span>
          </div>
          <div class="td flex_td">
            <span>{{ item.NominalStateQuarterLen }}</span>
            <span>{{ item.NominalStateQuarterRate }}</span>
          </div>
          <div class="td flex_td">
            <span>{{ item.NominalStateHalfLen }}</span>
            <span>{{ item.NominalStateHalfRate }}</span>
          </div>
          <div class="td">{{ item.AssembleLength }}</div>
        </div>
        <p class="statement">声明：本工具仅供医疗专业人士使用，计算结果仅供医疗专业人士参考，最终以医疗专业人士的临床决策为准。</p>
      </div>
      </template>
      <div class="tips" v-else>
        <img src="@/assets/images/rotate.png" />
        <p>请锁屏后横屏观看</p>
      </div>
    </div>
    <van-dialog v-model="show" title="近/远端血管直径" show-cancel-button @confirm="onConfirm">
      <div class="dialogInputBox">
        <div class="inputbox">
          <van-field class="dialogInput" v-model="dialogInput" type="number" placeholder="请输入近端血管直径（范围:1.50~7.00）" />&nbsp;mm
        </div>
        <div class="inputbox">
          <van-field class="dialogInput" v-model="dialogInput1" type="number" placeholder="请输入远端血管直径（范围:1.50~7.00）" />&nbsp;mm
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import utils from "../../common/utils/utils";
export default {
  name: 'ChoydarTool',
  data() {
    return {
      landscape: false,
      show: false,
      searchValue: '',
      searchValue1: '',
      dialogInput: '',
      dialogInput1: '',
      data: [],
      loading: false,
      error: null
    }
  },
  created() {
    // this.loadData()
    this.initShare();
    this.getList();
  },
  activated() {
    window.addEventListener("resize", this.renderResize, false)
  },
  deactivated () {
    window.removeEventListener("resize", this.renderResize, false)
  },
  methods: {
    initShare() {
      let that = this;
      const entryLink = utils.getEntryLink();
      that.$axios
        .get("/Api/Api/web/ShareLog/wxHelp?backUrl=" + entryLink)
        .then((res) => {
          wx.config({
            debug: false,
            appId: 'wxf77916b15f3905df',
            timestamp: res.Data.TimesTamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.She1Str,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
          });
          wx.checkJsApi({
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData", // 分享到朋友圈接口
              "updateTimelineShareData", //  分享到朋友接口
            ],
            success: async function (res) {
              wx.ready(() => {
                wx.updateAppMessageShareData({
                  title: '强易达型号一览表',
                  link: window.location.href,
                  desc: '',
                  imgUrl: "https://jpubliccnv.jjmc.cn/api/UploadImg/0340fb7a72664b15ab40778eee55889a.jpg",
                  success: function (res) {},
                });
                wx.updateTimelineShareData({
                  title: '强易达型号一览表',
                  link: window.location.href,
                  desc: '',
                  imgUrl: "https://jpubliccnv.jjmc.cn/api/UploadImg/0340fb7a72664b15ab40778eee55889a.jpg",
                  success: function (res) {},
                });
              });
            },
          });
        });
    },
    async loadData() {
      try {
        const response = await fetch('/choydarData.json?t=' + Date.now());
        
        this.data = await response.json()
      } catch (error) {
        console.error('Error loading JSON data:', error)
      }
    },
    getList() {
      this.$axios.post('/Api/api/Web/GetCedFDRate/GetCedFDRateList').then(res => {
        this.data = res.Data;
      })
    },
    renderResize() {
        // 判断横竖屏
        let width = document.documentElement.clientWidth
        let height = document.documentElement.clientHeight
        if (width > height) {
          this.landscape = true;
        } else {
          this.landscape = false;
        }
    },
    showInput() {
      this.show = true;
    },
    onConfirm() {
      this.searchValue = this.dialogInput;
      this.searchValue1 = this.dialogInput1;
      this.search();
    },
    search() {
      this.data.forEach(item => {
        item.active = false;
      })

      if(this.searchValue && this.searchValue1) {
        // if((this.searchValue <= 1.5 && this.searchValue >= 7.0) || this.searchValue1 <= 1.5 && this.searchValue1 >= 7.0) {
          // this.$refs[`tr0`][0].scrollIntoView({
        //     behavior: 'smooth'
        //   });
        //   this.$dialog.alert({
        //     title: '提示',
        //     message: '血管直径（范围：1.50~7.00），您输入的值已超出范围！',
        //     getContainer: ".container"
        //   }).then(() => {});
        // } else {
          let maxValue = (this.searchValue > this.searchValue1) ? this.searchValue : this.searchValue1;
          let searchValue = maxValue * 100;
          let hasSearchValue = this.data.some(item => item.Specification == searchValue);
          if(hasSearchValue) {
            this.data.forEach(item => {
              if(item.Specification == searchValue ) {
                item.active = true;
              }
            })
          } else {
            // let leftArr = this.data.filter(item => item.value < searchValue);
            let rightArr = this.data.filter(item => item.Specification > searchValue);

            // if(leftArr.length > 0) {
            //   let leftValue = leftArr[leftArr.length - 1].value;
            //   this.data.forEach(item => {
            //     if(item.value == leftValue ) {
            //       item.active = true;
            //     }
            //   })
            // }

            if(rightArr.length > 0) {
              let rightValue = rightArr[0].value;
              this.data.forEach(item => {
                if(item.Specification == rightValue ) {
                  item.active = true;
                }
              })
            }
          }

          let index = this.data.findIndex(item => item.active == true);
          if(index != -1) {
            this.$refs[`tr${index}`][0].scrollIntoView({
              behavior: 'smooth'
            });
          }
        // }
      } else {
        // this.$dialog.alert({
        //   title: '提示',
        //   message: '请输入近端血管直径（范围:1.50~7.00）',
        //   getContainer: ".container"
        // }).then(() => {});
      }
      
      this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .van-field__control::-webkit-input-placeholder {
    font-size: 13px;
    font-weight: 400;
}
.container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  padding: 10px 10px 20px;
  box-sizing: border-box;
  font-size: 13px;
  .title {
    text-align: center;
    font-size: 15px;
    font-weight: bold;

  }
  .box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .inputBox {
    flex: 1;
    display: flex;
    align-items: center;
    margin: 10px 0;
    .input {
      width: 35%;
      height: 30px;
      line-height: 30px;
      padding: 0 8px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      border-radius: 6px;
    }
    .search {
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #FFFFFF;
      background-color: #409EFF;
      border-radius: 6px;
      margin-left: 10px;
    }
  }
  .crCode {
    font-size: 10px;
    text-align: right;
  }
  .table_header {
    display: flex;
    align-items: center;
    border: 1px solid #e7e7e7;
    background-color: #F5F7FA;
    .td {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
      height: 100%;
      text-align: center;
      line-height: 26px;
    }
    .td:not(:last-of-type) {
      border-right: 1px solid #e7e7e7;
    }
    .td:last-child {
      flex: none;
      width: 60px;
    }
    .td:first-child {
      flex: none;
      width: 80px;
    }
    .flex_header {
      display: flex;
      border-top: 1px solid #e7e7e7;
      span {
        flex: 1;
      }
      span:first-child {
        border-right: 1px solid #e7e7e7;
      }
    }
  }
  .table_body {
    flex: 1;
    overflow-y: scroll;
    .table_body_tr {
      display: flex;
      line-height: 28px;
      text-align: center;
      border-bottom: 1px solid #e7e7e7;
      .td {
        flex: 1;
        border-left: 1px solid #e7e7e7;
      }
      .td:last-child {
        border-right: 1px solid #e7e7e7;
      }
      .flex_td {
        display: flex;
        span {
          flex: 1;
        }
        span:first-child {
          border-right: 1px solid #e7e7e7;
        }
      }
      .td:last-child {
        flex: none;
        width: 60px;
      }
      .td:first-child {
        flex: none;
        width: 80px;
      }
    }
    .bg {
      background-color: #f0f0f0;
    }
    .active {
      background-color: #85BFFE;
    }
  }
}

.dialogInputBox {
  padding: 20px;
  .inputbox {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .dialogInput {
    flex: 1;
    height: 30px;
    line-height: 30px;
    padding: 0 8px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    border-radius: 6px;
  }
  .inputbox:not(:last-child) {
    margin-bottom: 15px;
  }
}

.tips {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  color: #FFFFFF;
  font-size: 10px;
  img {
    width: 40px;
    margin-bottom: 15px;
  }
}
.statement {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 0 10px;
  height: 20px;
  line-height: 20px;
  box-sizing: border-box;
  font-size: 11px;
  color: #FFFFFF;
}

@media screen and (orientation: portrait) {
  .container {
    width: 100vh;
    height: 100vw;
    transform: rotate(90deg);
    transform-origin: left top;
    position: absolute;
    left: 100%;
    top: 0;
  }
}
</style>